
/*
*
* File JS per la Archive News
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSingle from 'components/heroes/hero-single';
import blockTitle from 'components/block-title/block-title';

import featuredNews from 'components/news/featured-news';
import listNews from 'components/news/list-news'; 
import cardNews from 'components/news/card-news';


//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-news.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    featuredNews();
    listNews();
});

//--------------------------------------------------------------------//